module.exports = __webpack_public_path__ + "static/media/Inxise-logo.7ccef715.png";